module.exports = __webpack_public_path__ + "img/g20favor.7c444cf5.jpg";